// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RoomListModel from '../../model/room-list-model';
import RoomListDTO from '../dto/room-list-dto';
import dtoSchema from '../schemas/room-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import Int64LookupModel from '../../model/int64-lookup-model';
import BuildingListModel from '../../model/building-list-model';

export default abstract class RoomListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RoomListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
      this.details = data.details ?? undefined;
      this.group = data.group ? Int64LookupModel.toModel(data.group) : undefined;
      this.sortOrder = data.sortOrder;
      this.shortName = data.shortName ?? undefined;
      this.floor = data.floor ?? undefined;
      this.roomType = data.roomType ? Int64LookupModel.toModel(data.roomType) : undefined;
      this.building = data.building ? BuildingListModel.toModel(data.building) : undefined;
      this.schedulerResourceType = data.schedulerResourceType;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;
  /**
  */
  details?: string[];
  /**
  */
  group?: Int64LookupModel;
  /**
  * @type {int32}
  */
  sortOrder?: number;
  /**
  */
  shortName?: string;
  /**
  */
  floor?: string;
  /**
  */
  roomType?: Int64LookupModel;
  /**
  */
  building?: BuildingListModel;
  /**
  * @type {int32}
  */
  schedulerResourceType?: 0 | 1 | 2 | 3 | 4 | 5; // ResourceTypeDTO

  static toModel(dto: DeepPartial<RoomListDTO>): RoomListModel;
  static toModel(dto: DeepPartial<RoomListDTO> | undefined | null): RoomListModel | undefined;
  static toModel(dto: DeepPartial<RoomListDTO> | undefined | null): RoomListModel | undefined {
    return dto ? new RoomListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RoomListModel> | RoomListModel): RoomListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
      details: unwrapped.details,
      group: unwrapped.group,
      sortOrder: unwrapped.sortOrder,
      shortName: unwrapped.shortName,
      floor: unwrapped.floor,
      roomType: unwrapped.roomType,
      building: unwrapped.building,
      schedulerResourceType: unwrapped.schedulerResourceType,
    } as RoomListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RoomListModel, can not map to RoomListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
